import { render, staticRenderFns } from "./Inscription-private.vue?vue&type=template&id=1fc910d0&scoped=true&"
import script from "./Inscription-private.vue?vue&type=script&lang=js&"
export * from "./Inscription-private.vue?vue&type=script&lang=js&"
import style0 from "./Inscription-private.vue?vue&type=style&index=0&id=1fc910d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc910d0",
  null
  
)

export default component.exports